import { CONFIG_PAGES, ENTITY_NAMES, PERMISSIONS } from "@miplatform/constants";
import {
  CalendarEventType,
  CalendarFollowUpDisplay,
  WorkEntityType,
} from "@miplatform/types";

export const TRAY_NEWEST_FIRST_SORT = "modifiedOn desc";

export const TRAY_NEWEST_LAST_SORT = "modifiedOn asc";

export const TRAY_SORT_OPTIONS = [
  { label: "Newest First", value: TRAY_NEWEST_FIRST_SORT },
  { label: "Newest Last", value: TRAY_NEWEST_LAST_SORT },
];

export const FOLLOW_UP_DISPLAY_OPTIONS = Object.values(
  CalendarFollowUpDisplay
).map((value) => ({
  label: value,
  value,
}));

export const NEW_ORDERS_TRAY_FILTERS =
  "((attemptStatus eq 'New') and (previousStatus ne 'Hold'))";

export const FOLLOW_UP_TRAY_FILTERS =
  "((attemptStatus eq 'Hold') and (isOrderFollowupDue eq true)) or (attemptStatus eq 'New' and previousStatus eq 'Hold')";

export const READY_TO_SCHEDULE_TRAY_FILTERS = "attemptStatus eq 'Ready'";

export const TRAY_TYPE_OPTIONS = [
  { label: "New Orders", value: NEW_ORDERS_TRAY_FILTERS },
  { label: "Follow-Up", value: FOLLOW_UP_TRAY_FILTERS },
  { label: "Ready To Schedule", value: READY_TO_SCHEDULE_TRAY_FILTERS },
];

export const SERVICE_AREAS_LIMIT = 7;

export const MIN_SERVICE_AREA_RADIUS = 1;

export const TRAYS_LIMIT = 5;

export const CALENDAR_PAGE_CONFIG = {
  [CalendarEventType.Order]: {
    calendarName: "Order",
    entityName: ENTITY_NAMES.ORDER_TEMPLATE,
    entityNamePlural: ENTITY_NAMES.ORDER_TEMPLATES,
    permissions: PERMISSIONS.ORDER,
    workEntity: WorkEntityType.Order,
    configPage: CONFIG_PAGES.ORDER_CALENDARS,
  },
  [CalendarEventType.WorkOrder]: {
    calendarName: "Work Order",
    entityName: ENTITY_NAMES.WORK_ORDER_TEMPLATE,
    entityNamePlural: ENTITY_NAMES.WORK_ORDER_TEMPLATES,
    permissions: PERMISSIONS.WORK_ORDER,
    workEntity: WorkEntityType.WorkOrder,
    configPage: CONFIG_PAGES.WORK_ORDER_CALENDARS,
  },
  [CalendarEventType.Inspection]: {
    calendarName: "Inspection",
    entityName: ENTITY_NAMES.INSPECTION_TEMPLATE,
    entityNamePlural: ENTITY_NAMES.INSPECTION_TEMPLATES,
    permissions: PERMISSIONS.INSPECTION,
    workEntity: WorkEntityType.Inspection,
    configPage: CONFIG_PAGES.ORDER_CALENDARS,
  },
};
